import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = {};

theme.dark = createMuiTheme({
  appBar: {
    color: 'white',
  },
  palette: {
    type: 'dark',
    primary: {
      main: '#6ac56e',
    },
    recentlySeen: {
      backgroundColor: '#716e61',
    },
    fieldBorder: 'rgb(115 115 115)',
  },
});

theme.light = createMuiTheme({
  // direction: "rtl",
  appBar: {
    color: 'white',
  },
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    recentlySeen: {
      backgroundColor: '#fff5de',
    },
    fieldBorder: 'rgb(203 203 203)',
  },
});

export default theme;
